/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiCrawlerFromJSON, ApiCrawlerToJSON, } from './ApiCrawler';
import { ApiDataFromJSON, ApiDataToJSON, } from './ApiData';
export function ApiUserAgentFromJSON(json) {
    return ApiUserAgentFromJSONTyped(json, false);
}
export function ApiUserAgentFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'browser': !exists(json, 'browser') ? undefined : json['browser'],
        'browserNameId': !exists(json, 'browserNameId') ? undefined : json['browserNameId'],
        'browserVersionId': !exists(json, 'browserVersionId') ? undefined : json['browserVersionId'],
        'crawler': !exists(json, 'crawler') ? undefined : ApiCrawlerFromJSON(json['crawler']),
        'crawlerId': !exists(json, 'crawlerId') ? undefined : json['crawlerId'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'data': !exists(json, 'data') ? undefined : ApiDataFromJSON(json['data']),
        'id': !exists(json, 'id') ? undefined : json['id'],
        'isMobile': !exists(json, 'isMobile') ? undefined : json['isMobile'],
        'os': !exists(json, 'os') ? undefined : json['os'],
        'osId': !exists(json, 'osId') ? undefined : json['osId'],
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
        'userAgent': !exists(json, 'userAgent') ? undefined : json['userAgent'],
    };
}
export function ApiUserAgentToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'browser': value.browser,
        'browserNameId': value.browserNameId,
        'browserVersionId': value.browserVersionId,
        'crawler': ApiCrawlerToJSON(value.crawler),
        'crawlerId': value.crawlerId,
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'data': ApiDataToJSON(value.data),
        'id': value.id,
        'isMobile': value.isMobile,
        'os': value.os,
        'osId': value.osId,
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
        'userAgent': value.userAgent,
    };
}
